import "../../../chunk-D57E6H3M.mjs";

// src/components/primitive/ChatImageView/lightboxHooks.ts
import { useComponentsTranslation } from "../../../i18n/useComponentsTranslation.mjs";
function useLightboxTriggerProps(alt, open) {
  const { t } = useComponentsTranslation();
  return {
    "role": "button",
    "tabIndex": 0,
    "aria-label": alt ? t("chatImage.viewLargerAriaNamed", { name: alt }) : t("chatImage.viewLargerAria"),
    "onKeyDown": (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        open();
      }
    }
  };
}
export {
  useLightboxTriggerProps
};
//# sourceMappingURL=lightboxHooks.mjs.map